"use client";
import { motion } from "framer-motion";
import image2 from "../../../assets/Text-Image/image 9.svg";

const EmpoweringSuccess = () => {
  return (
    <section className="bg-gradient-to-br from-slate-900 to-slate-800 max-w-screen-xl mx-auto py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fillRule='evenodd'%3E%3Cg fill='%23ffffff' fillOpacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
            backgroundSize: "60px 60px",
          }}></div>
      </div>

      <div className="max-w-7xl mx-auto">
        {/* Title and Description */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-400 mb-6">
            Empowering Your Success
          </h2>
          <p className="text-slate-300 leading-relaxed max-w-3xl mx-auto text-lg">
            At M2HSE, we're committed to providing accredited training and
            innovative solutions that drive growth and efficiency. As a trusted
            partner for professionals and organizations across the UK, we equip
            you with the tools, knowledge, and support needed to achieve
            excellence.
          </p>
        </div>

        {/* Main Content: Left and Right Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Section */}
          <div className="space-y-6">
            {[
              {
                title: "Accredited Training",
                description:
                  "Delivering industry-recognised certifications like CITB courses and NVQs to help you stay ahead.",
                icon: "🏆",
                delay: 0,
              },
              {
                title: "Proven Expertise",
                description:
                  "Trusted by hundreds of businesses and professionals for our commitment to quality and results.",
                icon: "⭐",
                delay: 0.2,
              },
              {
                title: "Real Impact",
                description:
                  "98% of our clients report improved performance and compliance after working with us.",
                icon: "📈",
                delay: 0.4,
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-slate-800/50 p-6 rounded-xl shadow-lg border-l-4 border-red-500 hover:bg-slate-800/80 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-slate-300">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Section */}
          <div className="relative">
            <div className="absolute rounded-xl blur-lg opacity-20 "></div>
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src={image2 || "/placeholder.svg"}
                alt="Team Working Together"
                className="w-full h-auto rounded-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-end">
                <div className="p-6">
                  <p className="text-white font-medium">
                    "Our training has helped many professionals advance their
                    careers in construction and safety."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Text */}
        <p className="text-center italic text-slate-300 mt-16 max-w-3xl mx-auto">
          Join the growing community of satisfied clients who trust us to
          transform their capabilities. Let us empower you every step of the
          way!
        </p>
      </div>
    </section>
  );
};

export default EmpoweringSuccess;
